import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const ImageIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
    {...props}
  >
    <Path
      d="M18.2333 4H7.56666C6.85942 4 6.18114 4.28095 5.68104 4.78105C5.18095 5.28115 4.89999 5.95942 4.89999 6.66667V17.3333C4.89999 18.0406 5.18095 18.7189 5.68104 19.219C6.18114 19.719 6.85942 20 7.56666 20H18.2333C18.9406 20 19.6188 19.719 20.1189 19.219C20.619 18.7189 20.9 18.0406 20.9 17.3333V6.66667C20.9 5.95942 20.619 5.28115 20.1189 4.78105C19.6188 4.28095 18.9406 4 18.2333 4ZM7.56666 5.77778H18.2333C18.4691 5.77778 18.6952 5.87143 18.8619 6.03813C19.0286 6.20483 19.1222 6.43092 19.1222 6.66667V14.0978L16.2778 11.6711C15.8371 11.3085 15.2841 11.1102 14.7133 11.1102C14.1426 11.1102 13.5896 11.3085 13.1489 11.6711L6.67777 17.0667V6.66667C6.67777 6.43092 6.77142 6.20483 6.93812 6.03813C7.10482 5.87143 7.33091 5.77778 7.56666 5.77778ZM18.2333 18.2222H8.06444L14.2867 13.0311C14.4062 12.9424 14.5511 12.8944 14.7 12.8944C14.8489 12.8944 14.9938 12.9424 15.1133 13.0311L19.1222 16.4444V17.3333C19.1222 17.5691 19.0286 17.7952 18.8619 17.9619C18.6952 18.1286 18.4691 18.2222 18.2333 18.2222Z"
      fill={color}
    />
  </Svg>
);

export default ImageIcon;
